// @flow
import * as React from 'react';
import Modal from './Modal.js';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import helpers from '../util/helpers'


import "../css/FAQ.css";

type FAQModalProps = {
  onClose: () => void,
};

class FAQModal extends React.Component<FAQModalProps> {
  constructor(props) {
    super(props);
    this.numFAQs = props.numFAQs;
    this.state = {
      expanded: new Array(props.numFAQs).fill(false),
    };
  }

  onClose() {
    this.props.onClose();
  }

  render() {
    let common_questions = []
    let self = this;
    for (let i = 0; i < this.numFAQs; i++) {
      let expanded = this.state.expanded[i]
      let toggleFunction = function() {
        let expanded = self.state.expanded;
        if (!expanded[i]) {
          helpers.eventLog(`faq: expand question - ${i}`)
        } else {
          helpers.eventLog(`faq: collapse question - ${i}`)
        }
        expanded[i] = !expanded[i];
        self.setState({
          expanded: expanded
        })
      };

      let q_props = {
        key: 'title'+(i+1),
        className: "question expanded-"+expanded,
        onClick: toggleFunction,
      }
      let q_text_id = `common_questions.q${i+1}.title`
      let a_props = {
        key: 'content'+(i+1),
        className: "answer expanded-"+expanded,
      }
      let a_text_id = `common_questions.q${i+1}.content`

      let q = (<div {...q_props}>
                <div className={`chevron-faq ${expanded}`}><span/></div>
                <span className="q-text"><FormattedMessage id={q_text_id} /></span>
              </div>)
      common_questions.push(q)

      if (this.state.expanded[i]) {
        let a = (<div {...a_props}><span className="a-text"><FormattedHTMLMessage id={a_text_id} /></span></div>)
        common_questions.push(a)
      }

    }

    return (
      <Modal fullScreen={true} onClose={this.onClose.bind(this)} className='common-questions'>
      <h2>
      <FormattedMessage id='common_questions.title' defaultMessage='Common Questions' />
      </h2>

      <FormattedHTMLMessage id='common_questions.contact' defaultMessage='test' />

      {common_questions}
      </Modal>
    )
  }
}

type Props = {
  appState: AppStateType
};

type State = {
  open: boolean
};

class FAQ extends React.Component<Props, State> {
  constructor() {
    super();
    this.state = { open: false };
  }

  onClick() {
    helpers.eventLog("modal - nav:faq");
    this.setState({ open: true });
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  }

  onClose() {
    this.setState({ open: false });
    document.getElementsByTagName("body")[0].style.overflow = "visible";
  }

  render() {
    const modal = this.state.open ? <FAQModal numFAQs={this.props.numFAQs} onClose={this.onClose.bind(this)} /> : null;

    return (
      <div className="faq-wrapper">
        <div className='faq-button' onClick={this.onClick.bind(this)} onTouchStart={this.onClick.bind(this)}>
          <div>
            <span>?</span>
          </div>
        </div>

        {modal}
      </div>
    )
  }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/components/FAQ.js